// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e41772f0","455":"d4d821a7","977":"6d749a7b"}[chunkId] + ".chunk.js";
};